import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/sortable'

document.addEventListener('initialize', function() {
  function fixWidthHelper(e, ui) {
    ui.children().each(function () {
      $(this).width($(this).width());
    });
    return ui;
  }

  $('.sortable').sortable({
    helper: fixWidthHelper,
    handle: '.handle',
    update: function(e, ui) {
      $.ajax({
        url: $(this).data("url"),
        type: "PATCH",
        data: $(this).sortable('serialize'),
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
      })
    }
  })
});
